import styled from 'styled-components'

export const Container = styled.div`
    width: auto;
    height: 100%;
    padding: 1.5%;
    border: 1px solid ${({ theme }) => theme['gray-400']};

    .public-DraftEditor-content {
        max-height: 200px;
        overflow: auto;
    }

    .public-DraftStyleDefault-ltr {
        direction: ltr;
        text-align: unset;
        margin: 0;
        padding: 0;
    }

    // DraftJS block styles
    .ds_textCentered {
        text-align: center;
        word-break: break-word;
    }

    .ds_textOnRight {
        text-align: right;
        word-break: break-word;
    }

    .ds_texJustified {
        text-align: justify;
        word-break: break-word;
    }

    .ds_blockquote {
        display: flex;
        justify-content: center;
        font-family: fantasy;
        text-align: center;
        content: open-quote;
        background: ${({ theme }) => theme['gray-100']};
        border-left: 10px solid #ccc;
        border-right: 0.1px solid ${({ theme }) => theme['gray-200']};
        border-bottom: 0.1px solid ${({ theme }) => theme['gray-200']};
        border-top: 0.1px solid ${({ theme }) => theme['gray-200']};
        padding: 8px;
        word-break: break-word;
        max-width: auto;
        margin-left: 15%;
        margin-right: 15%;
    }
`

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    width: auto;
    height: fit-content;
    margin-bottom: 10px;
`

export const Menu = styled.section`
    display: flex;
    justify-content: flex-end;
    width: 70%;
`

export const Tip = styled.section`
    display: flex;
    justify-content: flex-start;
    margin-top: 6px;
    width: 30%;
`

export const BlockLabel = styled.label`
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-800']};
    margin-left: 2px;
`
